searchHandler = {
  $startSearch : $('.start-search'),
  $textSearch : $('.text-search'),
  $textSearchTerm : $('.text-search.search-term'),
  $textSearchCell : $('.text-search-cell'),
  $suggestPanel : $('#suggest-panel'),
  $defaultSuggest : $('#default-suggest'),
  $searchedSuggest : $('#searched-suggest'),
  $listSearched : $('.list-searched'),
  $listSuggest : $('.list-item-container'),
  $smallTxtSearch : $('.small-txt-search'),
  $closePanelSearch : $('[href=#close-panel-search]'),
  $panelSuggestContainer : $('.panel-suggest-container'),
  $html : $('html'),
  isLoad: false,
  $collImage: $('.coll-image'),
  indexHtml: '',
  sugestTimeout: null,
  // Ordered poster ids of the current result set (response.ids of the last query call). Paging
  // renders a slice of this list instead of re-running the query.
  resultIds: [],
  resultCount: 0,
  // Filter / search / sort / page state of the current visit, seeded from the URL by
  // indexHandler.loadByParams() and POSTed by loadData(). Shape: [{ type: '', value: [] }].
  // Deliberately NOT persisted (no cookie): the URL is the contract, see cline-context §7/§8.
  filterState: [],

  setSuggest : function($obj, showSuggestSearched = false){
    var self = this;
    var text = $obj.val();

    if (text.length < 2) {
      if (showSuggestSearched == false) {
        self.$defaultSuggest.addClass('active');

        if (Foundation.MediaQuery.only('small'))
          $('.accessibility-widgets-container').hide();
      }
      self.$searchedSuggest.removeClass('active');
    } else {
      self.$searchedSuggest.addClass('active');     
      self.$defaultSuggest.removeClass('active');
      if (Foundation.MediaQuery.only('small'))
        $('.accessibility-widgets-container').show();   
    }
    //ajax request here
    self.lookupSuggestion(text, $obj);    
  },

  strToUpper: function(str) {
    var res = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
      return letter.toUpperCase();
    });
    return res; 
  },

  lookupSuggestion: function(val, $obj) {
    var self = this;
    val = val.toLowerCase();
    if (!$obj.parent().hasClass('left-panel-mode')) {
      self.$listSearched.children().removeClass('active').removeClass('last-suggest-category');
      
      if (val.length >= 2) {
        var isDataAvailable = false; 
        var $activeObj = null;
        var suggestResult = [];
        /* self.$listSearched.children().each(function(){
          var nm = $(this).data('name');
          if (nm) {
            var nmLower = nm.toLowerCase();
            console.log(nmLower.indexOf(val));
            
            if (nmLower.indexOf(val) > -1) {
              var char       = '<span class="highlight color-black">' + val.toLowerCase() + '</span>';
              var char2      = '<span class="highlight color-black">' + self.strToUpper(val) + '</span>';
              var newText    = nm.replace(val.toLowerCase(), char);
              newText        = newText.replace(self.strToUpper(val), char2);
              
              $(this).addClass('active');
              var $name = $(this).find('.name');
              if ($name) {
                $name.html(newText);
              }
              isDataAvailable = true;
              $activeObj = $(this);
            }
          }
        }); */

        self.$listSearched.find('.item[data-name]').remove();

        if (self.sugestTimeout) clearTimeout(self.sugestTimeout);

        var removeWords = ['the', 'as'];

        var regex = new RegExp(
          '^(' + removeWords.join('|') + ')\\s+',
          'i'
        );

        val = val.replace(regex, '');

        self.sugestTimeout = setTimeout(function() {
          self.$listSuggest.children().each(function(){
            var nm = $(this).data('name');
            if (nm) {
              var nmLower = nm.toLowerCase();
              
              if (nmLower.indexOf(val) > -1) {
                var cloneItem  = $(this).clone();
                var char       = '<span class="highlight color-black">' + val.toLowerCase() + '</span>';
                var char2      = '<span class="highlight color-black">' + self.strToUpper(val) + '</span>';
                var newText    = nm.replace(val.toLowerCase(), char);
                newText        = newText.replace(self.strToUpper(val), char2);
                
                cloneItem.addClass('active');
                var $name = cloneItem.find('.name');
                if ($name) {
                  $name.html(newText);
                }
                isDataAvailable = true;
                $activeObj = cloneItem;
                
                var score = 0;
                var idx = nmLower.indexOf(val);

                if (idx === 0) {
                  score = 0; // paling relevan
                } else if (new RegExp('\\b' + val, 'i').test(nm)) {
                  score = 1;
                } else if (idx < nm.length - val.length) {
                  score = 2;
                } else {
                  score = 3;
                }

                suggestResult.push({
                  score: score,
                  length: nm.length,
                  el: cloneItem
                });
                //suggestResult[nmLower.indexOf(val)] = cloneItem; 
                //self.$listSearched.append(cloneItem);
              }
            }
          });
          
          if (suggestResult) {
            suggestResult
              .sort(function(a, b){
                if (a.score !== b.score) {
                  return a.score - b.score;
                }
                return a.length - b.length;
              })
              .forEach(function(item){
                self.$listSearched.append(item.el);
              });
          }

          if (isDataAvailable == false) {
            self.$listSearched.find('.empty').addClass('active');
          } else {
            $activeObj.addClass('last-suggest-category');
          }
        }, 500);
      }
    } else {
      $filterLlistContainer = $($obj.parent().parent().next()[0]);
      $filterLlistContainer.children().addClass('hide');
      
      var isDecade = $filterLlistContainer.closest('.accordion-content').hasClass('type-decade');
      var $submitButton = $filterLlistContainer.siblings('button[type="submit"]')
      var hasResults = false;
      $submitButton.addClass('hide')

      if (val.length >= 2) {
        $filterLlistContainer.children().each(function(){
          var $input = $(this).find('input');
          if (isDecade) {
            var name = $input.data('year');
          } else {
            var name = $input.attr('name');
          }
          if (name.length > 0) {
            name = name.toLowerCase(); 
            if (name.indexOf(val) > -1) {
              $(this).removeClass('hide');
              hasResults = true
            }
          }
        });

        if (hasResults) {
          $submitButton.removeClass('hide')
        }
      }
    }
  },

  closePanelSearch: function(){
    this.$suggestPanel.removeClass('active');
    this.$defaultSuggest.removeClass('active');
    this.$searchedSuggest.removeClass('active');
    if (Foundation.MediaQuery.only('small'))
      $('.accessibility-widgets-container').show();   
  },

  doRedirectSearch: function(text) {
    this.setFilterState('search_term', text);
    // A new search is a new result set: back to page 1.
    this.setFilterState('page_index', 1);
    // The URL carries the state: indexHandler.updateUrl() writes search-query (plus the filters and
    // the sort), so a refresh, a bookmark or the poster page's BACK button returns to this list.
    indexHandler.updateUrl();
    this.closePanelSearch();
    this.loadData();
  },

  /**
   * Start from an empty state.
   *
   * The URL is the only source of state on a page load (indexHandler.loadByParams() calls this
   * before applying the URL params); the "Reset Filter" link calls it to clear everything.
   */
  resetFilterState: function() {
    this.filterState = [];
  },

  /**
   * Read one value out of the state ('' when the key is absent) — the state, not the markup, is
   * authoritative: e.g. the search term exists in two boxes (page + suggestion panel).
   *
   * @param string type state key
   * @return string
   */
  getFilterStateValue: function(type) {
    var value = '';

    (this.filterState || []).forEach(function(e) {
      if (!e || e.type !== type) return;

      if (e.value && e.value.length > 0 && e.value[0] !== '') {
        value = e.value[0];
      }
    });

    return value;
  },

  /**
   * Merge one piece of state into the in-memory filterState — the payload loadData() POSTs.
   *
   * Shape: [{ type: '', value: [] }], type one of designer|country|keyword|decade|search_term|
   * page_index|sort_field|sort_order. Nothing is persisted: the URL is the contract (cline-context §7).
   *
   * @param string type     state key
   * @param string value    term id / text / page number / sort value
   * @param bool   isRemove remove the value instead of adding it
   */
  setFilterState: function(type, value, isRemove = false) {
    var arrFilters = [];
    var addNewItem = false;
    var parsed = this.filterState || [];

    if (parsed.length > 0) {
      parsed.forEach(function(e) {
        if (!e) return;

        var arrVal = Array.isArray(e.value) ? e.value.slice() : [];
        var item = {
          type: e.type,
          value: arrVal
        };

        if (type === e.type) {
          if (type === 'search_term' || type === 'page_index') {
            arrVal = [value];
          } else {
            if (!isRemove && arrVal.indexOf(value) < 0) {
              arrVal.push(value);
            }
            if (isRemove && arrVal.indexOf(value) > -1) {
              arrVal.splice(arrVal.indexOf(value), 1);
            }
          }
          item.value = arrVal;
        } else {
          var isExist = parsed.some(function(itm) {
            return itm.type === type;
          });

          if (!isExist && !isRemove) {
            addNewItem = true;
          }
        }

        if (item.value.length > 0) {
          arrFilters.push(item);
        }
      });
    } else {
      addNewItem = !isRemove;
    }

    if (addNewItem) {
      var arrNewVal = [];
      var newItem = {};
      arrNewVal.push(value);
      newItem.type = type;
      newItem.value = arrNewVal;
      arrFilters.push(newItem);
    }

    this.filterState = arrFilters;
  },


  loadData: function(setTextSearch=false, setDisplaySelected=false, setCountOnly=false){
    var self = this;
    var $page_index = '1';
    var $sort_field = '';
    var $sort_order = '';
    var $filter_designer = '';
    var $filter_country  = '';
    var $filter_keyword  = '';
    var $filter_decade 	 = '';
    var $filter_text     = '';
    var $show_filter_sort= false;

    indexHandler.filterSet();
    
    // The filter/search/sort state of this visit lives in memory (seeded from the URL by
    // indexHandler.loadByParams()); nothing is persisted between page loads.
    var tmp = self.filterState;

    if (tmp.length > 0) {
      if (Object.keys(tmp).length > 0) {
        tmp.forEach(e => {
          if (e.type == 'page_index') {
            $page_index = e.value[0];
          }
          
          if (e.type == 'sort_field') {
            e.value.forEach(element => {
              if (element) {
                $sort_field = element
              }
            });
          }

          if (e.type == 'sort_order') {
            $sort_order = e.value[0];
          }

          if (e.type == 'designer') {
            // for (let index = 0; index < e.value.length; index++) {
            //     $filter_designer += ($filter_designer ? ',' : '') + e.value[index];
            // }
            $filter_designer = e.value;
            $show_filter_sort = true;
          }

          if (e.type == 'country') {
            $filter_country = e.value;
            $show_filter_sort = true;
          }
          
          if (e.type == 'keyword') {
            $filter_keyword = e.value;
            $show_filter_sort = true;
          }

          if (e.type == 'decade') {
            $filter_decade = e.value;
            $show_filter_sort = true;
          }

          if (e.type == 'search_term') {
            $filter_text = e.value[0];
            $show_filter_sort = true;
          }
        })
      }
    } else {
      indexHandler.$filterResult.removeClass('is-show');
      indexHandler.$sortContainer.addClass('is-hide');
      indexHandler.$filterResult.find('.result-text').attr('tabindex', '-1');
      indexHandler.$filterResult.find('.reset-button').attr('tabindex', '-1');
    }
    
    if (setTextSearch == true) {
      self.$textSearch.each(function(){
        if (!$(this).closest('.input-text-search-style').hasClass('left-panel-mode')){
          $(this).val($filter_text);
        }
      })
    }

    if (!setCountOnly) {
      indexHandler.$indexContainer.find('.panel-content-index').empty();
      indexHandler.$indexContainer.find('.panel-content-index').addClass('loading-container');
    }

    if (setDisplaySelected) {
      self.setDisplaySelectedFilter($filter_designer, $filter_country, $filter_keyword, $filter_decade );
    }

    if ($show_filter_sort) {
      indexHandler.$filterResult.addClass('is-show');
      indexHandler.$sortContainer.removeClass('is-hide');
    } 

    if (!setCountOnly && self.indexHtml) {
      indexHandler.$indexContainer.find('.panel-content-index').replaceWith(self.indexHtml);
      indexHandler.reinitializeMasonry();
      self.indexHtml = '';
    } else if (self.isLoad == false) {
      $.ajax({
        type: 'post',
        url: myAjax.ajax_url,
        data: {
          action     : 'load_index_paging',
          page_index : $page_index,
          sort_field : $sort_field,
          sort_order : $sort_order,
          filter_designer : $filter_designer,
          filter_country  : $filter_country,
          filter_keyword  : $filter_keyword,
          filter_decade 	: $filter_decade,
          filter_text     : $filter_text
        },
        beforeSend: function() {
          if (!setCountOnly) {
            self.$html.addClass('loading');
            self.isLoad = true;
            indexHandler.$indexContainer.find('.panel-content-index').empty();
          }

          indexHandler.$resultCount.html('');
          indexHandler.$resultSuffix.html('');
          indexHandler.$resultText.addClass('hide');
        },  
        success: function(response) {
          let $resultHtml = response['html'];
          if (!setCountOnly) {
            indexHandler.$indexContainer.find('.panel-content-index').replaceWith($resultHtml);
            indexHandler.reinitializeMasonry();
            self.$html.removeClass('loading');
            self.isLoad = false;
          } else {
            self.indexHtml = $resultHtml;
          }

          // Result set store for paging (see loadPage()): ordered ids of the whole set.
          self.resultIds   = (response['ids']) ? response['ids'] : [];
          self.resultCount = (response['all_count'] !== undefined) ? parseInt(response['all_count'], 10) : 0;

          // The server clamps a page that no longer exists (posters deleted, so the saved page is past
          // the end of the set): adopt the effective page and republish the URL, so the address bar
          // never points at a page that cannot be rendered.
          var $server_page = (response['page_index'] !== undefined) ? parseInt(response['page_index'], 10) : 0;

          if ($server_page > 0 && $server_page !== parseInt($page_index, 10)) {
            self.setFilterState('page_index', $server_page);
            indexHandler.updateUrl(true);
          }

          var itemCount = $($resultHtml).data('all-count');
          
          if (itemCount > 0) {
            indexHandler.$resultText.removeClass('hide');
            indexHandler.$resultCount.html(itemCount);

            if (itemCount > 1)
              indexHandler.$resultSuffix.html('s');
          }

          clearTimeout(indexHandler.loadTimeout);
          indexHandler.loadTimeout = null;
        },
      });
    }
  },

  /**
   * Paging: render one page out of the stored result set (resultIds).
   *
   * Paging does NOT re-run the query: the ids of the requested page are posted and the server
   * renders exactly those posters (action=load_index_paging, paging=1). Falls back to a normal
   * query when there is no store yet (e.g. the first request has not come back).
   */
  loadPage: function(pageIndex) {
    var self    = this;
    var $panel  = indexHandler.$indexContainer.find('.panel-content-index');
    var perPage = parseInt($panel.data('per-page'), 10) || 12;

    if (!self.resultIds || self.resultIds.length == 0) {
      self.setFilterState('page_index', pageIndex);
      indexHandler.updateUrl(true);
      self.loadData();
      return;
    }

    if (self.isLoad == true) return;

    var start   = (pageIndex - 1) * perPage;
    var pageIds = self.resultIds.slice(start, start + perPage);

    if (pageIds.length == 0) {
      // The stored result set is shorter than the requested page (posters edited or deleted since
      // it was fetched): re-query from page 1 instead of leaving a dead paging click.
      self.setFilterState('page_index', 1);
      indexHandler.updateUrl(true);
      self.loadData();
      return;
    }

    $.ajax({
      type: 'post',
      url: myAjax.ajax_url,
      data: {
        action     : 'load_index_paging',
        paging     : 1,
        page_index : pageIndex,
        all_count  : self.resultCount,
        post_ids   : pageIds.join(',')
      },
      beforeSend: function() {
        self.$html.addClass('loading');
        self.isLoad = true;
        $panel.empty().addClass('loading-container');
        indexHandler.$resultCount.html('');
        indexHandler.$resultSuffix.html('');
        indexHandler.$resultText.addClass('hide');
      },
      success: function(response) {
        indexHandler.$indexContainer.find('.panel-content-index').replaceWith(response['html']);
        indexHandler.reinitializeMasonry();
        self.$html.removeClass('loading');
        self.isLoad = false;

        self.setFilterState('page_index', pageIndex);
        // The page is part of the URL. replaceState (not push): stepping through pages is one visit,
        // so the browser back button leaves the collection instead of walking back through pages.
        indexHandler.updateUrl(true);

        if (self.resultCount > 0) {
          indexHandler.$resultText.removeClass('hide');
          indexHandler.$resultCount.html(self.resultCount);

          if (self.resultCount > 1)
            indexHandler.$resultSuffix.html('s');
        }
      }
    });
  },

  setDisplaySelectedFilter: function($filter_designer, $filter_country, $filter_keyword, $filter_decade ){
    var filters = [
      { type: 'designer', values: $filter_designer },
      { type: 'country',  values: $filter_country  },
      { type: 'keyword',  values: $filter_keyword  },
      { type: 'decade',   values: $filter_decade   }
    ];

    filters.forEach(function(filter){
      if (!filter.values) return;

      filter.values.forEach(function(element){
        // Scope to the taxonomy: the same term id can exist in more than one taxonomy.
        var $obj = $('.list-item-button.filter-'+filter.type+'[value="'+element+'"]');

        if ($obj.length == 0) return;

        $obj.prop('checked', true);
        $obj.each(function(){
          indexHandler.generateCloseItem($(this));
        });
      });
    });
  },

  init: function(){
    var self = this;

    if ( ((window.location.pathname.indexOf("index") < 0) && (window.location.pathname.indexOf("/poster/") < 0)) || (stateClearFilter)) {
      // Was: clear the filter cookie + reload on every non-collection page. The state now lives in
      // the URL, so there is nothing to clear here.
      //self.loadData(true, true);
    } else {
      // setTimeout(() => {
      //     this.loadData(true);    
      // }, 2000);
    }

    $(document).on('focusout', '.last-suggest-category', function(){
    //self.$panelSuggestContainer.find('.last-suggest-category, .item.active:last-of-type').on('focusout', function(e) {
      self.$suggestPanel.removeClass('active');
      self.setSuggest('', false);
    });
    
    this.$startSearch.on('click', function(e){
      e.preventDefault();      
      var text = $($(this).prev()).val();
      if ((text.length > 2) || (text == '')) {
        self.doRedirectSearch(text);
      } 
    })

    this.$textSearch.on('focus', function(){
      var showSuggest = $(this).data('show-suggest');
      var showSuggestSearched = $(this).data('show-suggest-searched');
      if ($(this).parents('.panel-suggest-container').length == 0 && ((showSuggest == true) || (showSuggestSearched == true))) {
        self.$suggestPanel.addClass('active');
        self.setSuggest($(this), showSuggestSearched);


        setTimeout(function() {
          var $input = self.$suggestPanel.find('.text-search');

          $input.focus();

          var val = $input.val();
          $input.val('').val(val);
        }, 500);
      }
    })
    // .blur(function(){
    //     var showSuggest = $(this).data('show-suggest');
    //     var showSuggestSearched = $(this).data('show-suggest-searched');
    //     if (((showSuggest == true) || (showSuggestSearched == true)) && ($('html.no-touchevents').length > 0)) {
    //         setTimeout(() => {
    //             self.closePanelSearch();
    //         }, 500);
    //     }
    // });
    // .on('keydown', function(e) {
    //     var showSuggest = $(this).data('show-suggest');
    //     var showSuggestSearched = $(this).data('show-suggest-searched');

    //     // When pressing arrow down, switch focus to the first active item inside suggestion panel
    //     if ((showSuggest == true) && e.key == 'ArrowDown') {
    //         console.log(self.$panelSuggestContainer.children('.suggest.active').find('a:first, .item.active:first a').get(0))
    //         self.$panelSuggestContainer.children('.suggest.active').find('a:first, .item.active:first a').get(0).focus()
    //         e.preventDefault();
    //     }
    // });

    // Keyboard event for suggestion panel
    this.$panelSuggestContainer.on('keydown', function(e) {
      // Close the panel when Esc key pressed
      if (e.key === 'Escape') {
        self.$panelSuggestContainer.removeClass('active')
      }
    });

    // Outside click of panelSuggestContainer, close the search panel
    $(window).on('click', function(e) {
      if (!self.$panelSuggestContainer.is(e.target)
        && self.$panelSuggestContainer.has(e.target).length === 0
        && !self.$textSearchCell.is(e.target)
        && self.$textSearchCell.has(e.target).length === 0)
      {
        self.closePanelSearch();
      }
    });

    // Keyboard event for listSearched item. User can use arrow key to navigate the item
    self.$listSearched.on('keydown', '.item', function(e) {
      var $el = $(this)

      switch (e.key) {
        case 'ArrowUp':
          var $prev = $el.prevAll('.active:first')
          if ($prev.length > 0) {
            $prev.find('a').get(0).focus()
          }
          e.preventDefault()
          break;

        case 'ArrowDown':
          var $next = $el.nextAll('.active:first')
          if ($next.length > 0) {
            $next.find('a').get(0).focus()
          }
          e.preventDefault()
          break;
      }
    })

    this.$textSearch.on('input', function(){
      var showSuggestSearched = $(this).data('show-suggest-searched');
      self.setSuggest($(this), showSuggestSearched);

      // var text = $(this).val();
      // if (text.length === 1) {
      //     var showSuggest = $(this).data('show-suggest');
      //     var showSuggestSearched = $(this).data('show-suggest-searched');
      //     if ((showSuggest == true) || (showSuggestSearched == true)) {
      //         self.$suggestPanel.addClass('active');
      //         self.setSuggest($(this), showSuggestSearched);
      //     }
      // }
    }).keyup(function(e){
      var text = $(this).val();
      var dataLeftPanel = $(this).data('left-panel');

      if ((dataLeftPanel == false) && (e.keyCode == 13) && (text.length > 0) || (e.keyCode == 13) && (text == '')) {
        self.doRedirectSearch(text);
      } 
      
      if ((dataLeftPanel == true) && (text == '')) {
        var $parentsSearch = $(this).closest('.search-box-container');
        if ($parentsSearch) {
          $parentsSearch.next().children().removeClass('hide');
          $parentsSearch.siblings('button[type="submit"]').removeClass('hide');
        }

        if ($(this).hasClass('see-all')) {
          $parentsSearch.parent().find('.list-item-container').addClass('hide');
          $parentsSearch.siblings('button[type="submit"]').addClass('hide');
        }
        
      }
    });       

    this.$smallTxtSearch.on('click', function(e){
      self.$suggestPanel.addClass('active');
      self.$defaultSuggest.addClass('active');
      self.$searchedSuggest.removeClass('active');
    })

    this.$closePanelSearch.on('click', function(e){
      self.closePanelSearch();
    })

    $('.panel-suggest-skip').on('click', function() {
      self.closePanelSearch();
    });
  }
}